const baseJson = () => {
    return {
        id: null,
        lanhDao: null,
        thuKy: null
    }
}

export const kyThayKSPL = {
    baseJson
}
